export const eligibilityQuestionnaireJSON = {
    'title': 'Online screeningssp\u00f8rgeskema (v.3 18.08.25)',
    'description': 'Tak for din interesse i vores forskningsprojekt :PlanetDiet: B\u00e6redygtige kostvaner og kardiometabolisk sundhed: en multi-omics tilgang i et randomiseret kontrolleret fors\u00f8g (RCT).  ',
    'pages': [
        {
            'name': 'page1',
            'elements': [
                {
                    'type': 'boolean',
                    'name': 'data_scree1',
                    'useDisplayValuesInDynamicTexts': false,
                    'title': '<span lang="DA" style="color: black; white-space-collapse: collapse; font-size: 11pt; font-family: Arial, sans-serif;">Jeg har l\u00e6st, forst\u00e5et og accepteret ovenst\u00e5ende.</span><span style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"></span>',
                    'hideNumber': true,
                    'clearIfInvisible': 'onComplete',
                    'isRequired': true,
                    'labelFalse': 'Nej',
                },
            ],
            'title': 'I dette sp\u00f8rgeskema vil vi stille dig nogle overordnede sp\u00f8rgsm\u00e5l, som omhandler kriterierne for at deltage i projektet PlanetDiet. Vi vil desuden bede om dine kontaktoplysninger, s\u00e5 vi kan informere dig om resultatet af din besvarelse og det videre forl\u00f8b.',
            'description': 'De data vi indsamler om dig i dette sp\u00f8rgeskema opsamles udelukkende for at lave en f\u00f8rsteh\u00e5ndsvurdering af om du eventuelt er egnet til at deltage i projektet. Den endelige vurdering foretages f\u00f8rst efter at du har f\u00e5et mere information om og givet dit samtykke til at deltage i projektet. Hvis du p\u00e5 baggrund af din besvarelse af sp\u00f8rgeskemaet findes egnet og du stadig er interesseret vil du modtage mere information om fors\u00f8get. Hvis du ikke findes egnet til projektet, vil du efter besked om dette, ikke blive ulejliget yderligere. Dine data vil blive behandlet af Unikk.me p\u00e5 vegne af K\u00f8benhavns Universitet. Dine kontaktoplysninger og besvarelser af dette sp\u00f8rgeskema behandles fortroligt, kan kun tilg\u00e5s af projektpersonalet og vil ikke blive delt med andre udenfor K\u00f8benhavns Universitet. Dine data vil blive gemt indtil alle egnede deltagere er blevet inkluderet, og herefter vil vi opt\u00e6lle: 1) hvor mange personer der har besvaret dette sp\u00f8rgeskema og 2) hvor mange personer vi fandt hhv. egnet eller uegnet. Efter opt\u00e6llingen vil din besvarelse af de enkelte sp\u00f8rgsm\u00e5l blive slettet og de vil aldrig blive offentliggjort eller anvendt, som et resultat i projektet.',
        },
        {
            'name': 'page2',
            'elements': [
                {
                    'type': 'boolean',
                    'name': 'data_scree2',
                    'title': 'Jeg har l\u00e6st dette:',
                    'hideNumber': true,
                    'isRequired': true,
                    'labelFalse': 'Nej',
                },
            ],
            'title': 'Dine rettigheder og K\u00f8benhavns Universitets forpligtelser:',
            'description': 'For at behandle personoplysninger skal der v\u00e6re et lovligt grundlag. Til indsamling af dine svar i dette sp\u00f8rgeskema finder K\u00f8benhavns Universitet lovligt grundlag for at behandle dine ikke-f\u00f8lsomme personoplysninger i Artikel 6, stk. 1, litra a) i GDPR. K\u00f8benhavns Universitet er forpligtet til at overholde GDPR og den danske databeskyttelseslov og herunder at oplyse dig om hvordan og med hvilket form\u00e5l vi behandler dine data. Hvis du har sp\u00f8rgsm\u00e5l om behandling af dine personoplysninger, kan du kontakte universitets databeskyttelsesr\u00e5dgiver (dpo@adm.ku.dk). Du kan l\u00e6se mere om dine rettigheder p\u00e5 Privatlivspolitik \u2013 K\u00f8benhavns Universitet (ku.dk). Hvis du mener, vi ikke har behandlet dine persondata ordentligt, kan du klage til Datatilsynet, dt@datatilsynet.dk, Carl Jakobsensvej 35, 2500 K\u00f8benhavn. Du b\u00f8r dog f\u00f8rst tage kontakt til databeskyttelsesr\u00e5dgiveren dpo@adm.ku.dk. Tak igen for din interesse og din villighed til at besvare sp\u00f8rgsm\u00e5lene nedenfor. Hvis du har yderligere sp\u00f8rgsm\u00e5l, som du ikke mener er blevet besvaret, er du velkommen til at skrive til os p\u00e5: planetdiet@sund.ku.dk',
        },
        {
            'name': 'page3',
            'elements': [
                {
                    'type': 'boolean',
                    'name': 'inclu1_scree',
                    'title': '<b style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"><span lang="DA" style="font-size: 11pt; font-family: Arial, sans-serif;">Er du mellem 45 og 70 \u00e5r?</span></b><span lang="DA" style="color: black; white-space-collapse: collapse; font-size: 11pt; font-family: Arial, sans-serif;">&nbsp;</span><span style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"></span>',
                    'correctAnswer': true,
                    'isRequired': true,
                    'validators': [
                        {
                            'type': 'expression',
                        },
                    ],
                    'labelFalse': 'Nej',
                },
                {
                    'type': 'boolean',
                    'name': 'inclu2_scree',
                    'title': '<span lang="DA" style="color: black; white-space-collapse: collapse; font-size: 11pt; font-family: Arial, sans-serif;"><b style="font-size: medium;"><span lang="DA" style="font-size: 11pt;">Har du \u00e9n eller flere kardiovaskul\u00e6re risikofaktorer (f.eks. overv\u00e6gt/fedme, forh\u00f8jet blodtryk, forh\u00f8jet glukose, forh\u00f8jet kolesterol)?</span></b><span style="font-size: medium;"></span>&nbsp;</span><span style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"></span>',
                    'isRequired': true,
                    'labelFalse': 'Nej',
                },
                {
                    'type': 'boolean',
                    'name': 'inclu3_scree',
                    'title': '<span lang="DA" style="color: black; white-space-collapse: collapse; font-size: 11pt; font-family: Arial, sans-serif;"><b style="font-size: medium;"><span lang="DA" style="font-size: 11pt;">Ryger du, eller bruger du i \u00f8jeblikket nikotinprodukter?</span></b></span>',
                    'isRequired': true,
                    'labelFalse': 'Nej',
                },
                {
                    'type': 'boolean',
                    'name': 'inclu4_scree',
                    'title': '<b style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"><span lang="DA" style="font-size: 11pt; font-family: Arial, sans-serif;">Er du diagnosticeret med diabetes mellitus, hjerte-kar-sygdom eller atrieflimren?</span></b><span style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"></span>',
                    'isRequired': true,
                    'labelFalse': 'Nej',
                },
                {
                    'type': 'boolean',
                    'name': 'inclu5_scree',
                    'title': '<b style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"><span lang="DA" style="font-size: 11pt; font-family: Arial, sans-serif;">Er du villig til at f\u00f8lge en kost, der inkluderer kylling, fisk eller en vegetarisk kost som led i fors\u00f8get?</span></b><span lang="DA" style="color: rgb(0, 0, 0); white-space-collapse: collapse; font-size: 11pt; font-family: Arial, sans-serif;">&nbsp;</span><span style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"></span>',
                    'labelFalse': 'Nej',
                },
                {
                    'type': 'boolean',
                    'name': 'inclu6_scree',
                    'title': '<span lang="DA" style="color: rgb(0, 0, 0); white-space-collapse: collapse; font-size: 11pt; font-family: Arial, sans-serif;"><b style="font-size: medium;"><span lang="DA" style="font-size: 11pt;">Forst\u00e5r du dansk b\u00e5de skriftligt og mundtligt?</span></b><span lang="DA" style="font-size: 11pt;">&nbsp;</span><span style="font-size: medium;"></span>&nbsp;</span><span style="color: rgb(0, 0, 0); font-size: medium; white-space-collapse: collapse;"></span>',
                    'isRequired': true,
                    'labelFalse': 'Nej',
                },
            ],
            'title': 'Inklusionskriterier',
        },
        {
            'name': 'page4',
            'elements': [
                {
                    'type': 'expression',
                    'name': 'go_back1',
                    'title': '<br>',
                    'description': 'G\u00e5 tilbage og acceptere, hvis du \u00f8nsker at forts\u00e6tte.',
                    'hideNumber': true,
                    'readOnly': true,
                },
            ],
            'visibleIf': '{data_scree1} = false',
            'title': 'Du skal acceptere, hvis du \u00f8nsker at forts\u00e6tte med at udfylde forscreeningsskemaet.',
        },
        {
            'name': 'page5',
            'elements': [
                {
                    'type': 'expression',
                    'name': 'go_back2',
                    'title': '<br>',
                    'description': 'G\u00e5 tilbage og acceptere, hvis du \u00f8nsker at forts\u00e6tte.',
                    'hideNumber': true,
                    'readOnly': true,
                },
            ],
            'visibleIf': '{data_scree2} = false',
            'title': 'L\u00e6s venligst teksten, g\u00e5 til bagsiden',
        },
    ],
    'triggers': [
        {
            'type': 'skip',
            'expression': '{data_scree1} = false',
            'gotoName': 'go_back1',
        },
        {
            'type': 'skip',
            'expression': '{data_scree2} = false',
            'gotoName': 'go_back2',
        },
    ],
    'calculatedValues': [
        {
            'name': 'include',
            'expression': 'iif(({inclu1_scree}=true and {inclu2_scree}=true and {inclu3_scree}=false and {inclu4_scree}=false and {inclu5_scree}=true and {inclu6_scree}=true), true, false)',
            'includeIntoResult': true,
        },
        {
            'name': 'exclude',
            'expression': '  iif(({inclu1_scree}=false or {inclu2_scree}=false or {inclu3_scree}=true or {inclu4_scree}=true or {inclu5_scree}=false or {inclu6_scree}=false), true, false)',
            'includeIntoResult': true,
        },
    ],
    'showCompletedPage': false,
};
